import { Link, RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const Footer = ({ fields }) => {
  return (
    <div
      className="vds-form-footer"
      id="vds-form-footer"
      data-testid={`${fields.testid?.value}-section`}
    >
      <div className="vds-form-footer__inner">
        <div
          className="vds-form-footer__text-container"
          data-testid={`${fields.testid?.value}-text-container`}
        >
          <RichText tag="p" field={fields.text} data-testid={`${fields.testid?.value}-text`} />
        </div>

        <div className="vds-form-footer__ctas-container">
          <Link
            className="vds-form-footer__cta"
            rel="noopener noreferrer"
            target="_blank"
            field={fields.cookiesLink}
            data-testid={`${fields.testid?.value}-cookies-link`}
          />
          <Link
            className="vds-form-footer__cta"
            rel="noopener noreferrer"
            target="_blank"
            field={fields.privacyLink}
            data-testid={`${fields.testid?.value}-privacy-link`}
          />
        </div>
        <div className="vds-form-footer__ctas-container">
          <Link
            className="vds-form-footer__cta"
            rel="noopener noreferrer"
            target="_blank"
            field={fields.legalLink}
            data-testid={`${fields.testid?.value}-legal-link`}
          />
          <Link
            className="vds-form-footer__cta"
            rel="noopener noreferrer"
            target="_blank"
            field={fields.tocLink}
            data-testid={`${fields.testid?.value}-toc-link`}
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
